export const DEALEAR_DEFAULT ={
    dealerName:'Capital Auto Group',
    dealerId: 1
}